import { createContext } from 'react-router';
import { type AppView } from '../../types/app';

export const viewContext = createContext<AppView>('main');
